import { formatCep, normalizeUf } from "./addressHelper";

const isBlank = (value) => value == null || String(value).trim() === "";
const clean = (value) => (isBlank(value) ? "" : String(value).trim());

// Salesforce record ids: 15 or 18 alphanumeric chars, always mixing letters and digits.
const SALESFORCE_ID_PATTERN = /^[a-zA-Z0-9]{15}(?:[a-zA-Z0-9]{3})?$/;

export const isSalesforceId = (value) =>
  typeof value === "string" && SALESFORCE_ID_PATTERN.test(value) && /\d/.test(value) && /[a-zA-Z]/.test(value);

// BillingState is dirty in Salesforce (sometimes it holds the city); only a recognizable UF is shown.
export const resolveDisplayUf = (details = {}) => normalizeUf(clean(details.state)) || "";

export const displayValue = (value) => (isBlank(value) ? "-" : String(value));

export const displayAddressField = (field, details = {}) => {
  if (field === "state") return resolveDisplayUf(details) || "-";
  const value = details[field];
  if (isBlank(value)) return "-";
  return field === "postalCode" ? formatCep(value) : String(value);
};

// Formats ISO dates (YYYY-MM-DD[...]) as DD/MM/YYYY and leaves anything else untouched.
export const formatDisplayDate = (value) => {
  if (isBlank(value)) return "-";
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
  return match ? `${match[3]}/${match[2]}/${match[1]}` : String(value);
};

export const agreementLabel = (record, index, t) => {
  const name = clean(record?.name);
  if (name && !isSalesforceId(name)) return name;
  return t("clientDetails.party.agreementFallback").replace("{n}", String(index + 1));
};

export const formatBrl = (value) => {
  if (value == null || value === "" || Number.isNaN(Number(value))) return "-";
  return Number(value).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};
